(function ($) {
    $(function () {
        if (location.hash !== undefined && location.hash !== null && location.hash.indexOf('#') === 0 && location.hash.indexOf('/') === -1) {
            $('.accordion__input' + location.hash).prop('checked', true);
        }
    });
})(jQuery);